export const typeDefs = `
  input ElevateTokensInput {
    accessToken: String
    idToken: String
  }
`;
